import styled from "styled-components";
import { DataUsageItem } from "@/schemas/EsimUsageResponse";
import { Divider } from "antd";

type DailyUsageListProps = {
  dataUsageList: DataUsageItem[];
  planType?: string;
};

const UsageListContainer = styled.div`
  width: 100%;
  // margin-top: 8px;
`;

const ListHeader = styled.div`
  width: 100%;
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: bold;
  text-align: start;
  `;

const UsageListItem = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
`;

const DateText = styled.span`
  font-weight: bold;
`;

const UsageText = styled.span`
  color: #666;
`;

export default function DailyUsageList({ dataUsageList, planType }: DailyUsageListProps) {
  const sortedUsageList = [...dataUsageList].sort((a, b) => {
    return b.usageDate.localeCompare(a.usageDate);
  });

  const groupedByDate = sortedUsageList.reduce((acc, item) => {
    const date = item.usageDate;
    if (!acc[date]) {
      acc[date] = 0;
    }
    acc[date] += parseInt(item.usage, 10) || 0;
    return acc;
  }, {} as Record<string, number>);

  const dailyUsageData = Object.entries(groupedByDate).map(([date, usage]) => ({
    date: formatDate(date),
    usage: formatUsage(usage),
  }));

  return (
    <UsageListContainer>
      <Divider style={{ margin: "8px 0" }} />
      <ListHeader>
        {planType === "Daily" ? "Daily Usage" : "Total Usage Breakdown"}
      </ListHeader>
      {dailyUsageData.map((item) => (
        <UsageListItem key={item.date}>
          <UsageText>{item.date}</UsageText>
          <UsageText>{item.usage} GB</UsageText>
        </UsageListItem>
      ))}
    </UsageListContainer>
  );
}

function formatDate(dateString: string): string {
  if (dateString.length !== 8) return dateString;

  const year = dateString.substring(0, 4);
  const month = dateString.substring(4, 6);
  const day = dateString.substring(6, 8);

  const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

function formatUsage(bytes: number): string {
  const gb = bytes / (1024 * 1024 * 1024);
  return gb.toFixed(2);
}
